import { Directive, Input, Inject } from '@angular/core';
import {
  NG_ASYNC_VALIDATORS,
  AbstractControl,
  ValidationErrors,
  Validators,
  AsyncValidator
} from '@angular/forms';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from '../tokens';
import { Observable, of } from 'rxjs';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Directive({
  // selector: '[esMsisdnValidator]'
  selector:
    // tslint:disable-next-line: directive-selector
    '[msisdn][formControlName],[msisdn][formControl],[msisdn][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: MsisdnValidatorDirective,
      multi: true
    }
  ]
})
export class MsisdnValidatorDirective implements AsyncValidator {
  @Input() required: boolean = undefined;
  @Input() enabled: boolean = undefined;

  msisdnValidator: { enabled: boolean; required: boolean; regex: string };

  constructor(
    @Inject(VALIDATORS_CONFIGURATION_TOKEN)
    configuration: ValidatorsConfiguration
  ) {
    this.msisdnValidator = configuration.msisdn;
  }

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if (this.required === undefined || this.required === null) {
      if (this.msisdnValidator.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    } else {
      if (this.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    }

    if (this.enabled === undefined || this.enabled === null) {
      if (this.msisdnValidator.enabled) {
        return control.value.match(new RegExp(this.msisdnValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    } else {
      if (this.enabled) {
        return control.value.match(new RegExp(this.msisdnValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    }

    return of(null);
  }
}
